module.exports = __webpack_public_path__ + "static/img/81-1.cdb798a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/81-1.jpg
// module id = QwgC
// module chunks = 0